<svg [ngClass]="class" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="2" y="2" width="30" height="30" rx="8.33333" fill="#FFFEFE"/>
  <path d="M17 23.6641L17 15.3307" stroke="#372121" stroke-width="3.33333" stroke-linecap="round"/>
  <path d="M17 10.3335L17 10.3516" stroke="#372121" stroke-width="3.33333" stroke-linecap="round"/>
  <path d="M32 17C32 29.3525 29.3525 32 17 32C4.6475 32 2 29.3525 2 17C2.00001 4.6475 4.64751 2 17 2C29.3525 2 32 4.6475 32 17Z" [style.stroke]="fillColor" stroke-width="3.33333"/>
</svg>

